module.exports = __webpack_public_path__ + "img/dsci0010.aea0254d.jpg";